<template>
    <div class="gameview-view">
        <transition @enter="onShowOverlay" @leave="onHideOverlay">
            <overlay :tile="currentTile" @close="hideOverlay" v-if="currentTile"></overlay>
        </transition>
        <memory-game @match="onGameMatch" @finish="onGameFinish"></memory-game>
        <!-- <button class="next-page" @click="goToEnd">klik2</button> -->
    </div>
</template>

<style lang="scss">

</style>

<script>
    import { TimelineMax } from 'gsap';
    import Memorygame from '@/app/components/Memorygame.vue';
    import Overlay from '@/app/components/Overlay.vue';
    export default {
        name: 'GameView',
        components: {
            'memory-game': Memorygame,
            'overlay': Overlay
        },
        data()
        {
            return { currentTile: null, gameFinished: false };
        },
        mounted()
        {

        },
        methods: {
            goToEnd()
            {
                this.$router.push( '/ending' );
            },
            getAnimateIn()
            {
                let tl = new TimelineMax();
                tl.to( '.memory-game', 0.3, { x: 65 });
                return tl;
            },
            getAnimateOut()
            {
                let tl = new TimelineMax();
                tl.to( '.memory-game', 0.3, { x: -65 });
                return tl;
            },
            onGameMatch( tile )
            {
                this.currentTile = tile;
                // console.log( tile );
            },
            onShowOverlay( el, done )
            {
                // window.alert( window.innerWidth + ',' + window.innerHeight );
                let tl = new TimelineMax();
                tl.fromTo( '.overlay-view', 0.3, { y: -65, opacity: 0 }, { y: 0, opacity: 1 });
                tl.add( done );
                return tl;
            },
            hideOverlay()
            {
                this.currentTile = null;
                if( this.gameFinished )
                {
                    this.goToEnd();
                }
            },
            onHideOverlay( el, done )
            {
                let tl = new TimelineMax();
                tl.fromTo( '.overlay-view', 0.3, { opacity: 1 }, { opacity: 0 });
                tl.add( done );
                return tl;
            },
            onGameFinish()
            {
                this.gameFinished = true;
            }
        }
    };
</script>
